/**
 * 柜型默认尺寸（高 / 深）只用来"预填"，用户随时能改。
 *
 * 换柜型时有个坑：用户手填过的高度/深度**绝不能被默认值覆盖**。
 * 所以只在两种情况下跟着新柜型走：
 * - 现在是空的；
 * - 现在正好等于**旧柜型**的默认值（说明还没改过）。
 */
export function shouldFollowTypeDefault(
  current: number | null | undefined,
  previousDefault: number | null | undefined,
  nextDefault: number | null | undefined,
): boolean {
  if (nextDefault === null || nextDefault === undefined) return false;
  if (current === null || current === undefined) return true;
  return current === previousDefault;
}
